/**
 * Created by Ning Jiang on 10/19/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneMultiplierController} from "../../multiplier/TombstoneMultiplierController";
import {ITombstoneParsedServerData} from "../../server/data/ITombstoneParsedServerData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {TombstoneFreespinIntroView} from "../freespinintro/TombstoneFreespinIntroView";

export class TombstoneSuperFreespinIntroController extends ScreenController {

    private _isRestoreSuperFreespin:boolean = false;
    private _isSuperFreespinWon:boolean = false;
    private _remainingFreeSpins:number;

    constructor(config:IScreenConfig) {
        super("SuperFreespinIntro", config);
        (<TombstoneFreespinIntroView>this._view).getPlaySoundCallback(() => this.playFSSound());
    }

    protected calculateIsTriggered(data:ITombstoneParsedServerData):boolean {
        const isRestoreState:boolean = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        this._isRestoreSuperFreespin = isRestoreState && data.freespinsLeft > 0 && data.nextMode === TombstoneGameMode.SUPER_FREESPIN;
        this._isSuperFreespinWon = data.superFreespinTriggeredThisSpin;
        this._remainingFreeSpins = data.freespinsLeft;
        return this._isSuperFreespinWon || this._isRestoreSuperFreespin;
    }

    protected shouldShow():boolean {
        return this._isSuperFreespinWon;
    }

    protected doTransitions():void {
        if(this.shouldShow()) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BOUNTY_INTRO);
        } else {
            this.playFSSound();
        }
        SlotGame.keypad.setZeroBetSpinCounter(this._remainingFreeSpins);
    }

    protected onCloseComplete():void {
        super.onCloseComplete();
        EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.SHOW_END_MULTIPLIER, !(this._isRestoreSuperFreespin && !this._isSuperFreespinWon)));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    private playFSSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.BOUNTY_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
    }
}